module.exports = __webpack_public_path__ + "img/times-light-white.330fe99a.svg";